import React, { useContext, useEffect, useState } from 'react'
import { TemplatePage } from '../../../../../components/TemplatePage'
import { StackNavigationProp } from '@react-navigation/stack'
import { LogisticsRoutes } from '../../../../../navigator/types'
import { CommonActions, useNavigation } from '@react-navigation/native'
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native'
import { globalStyle } from '../../../../../theme/global'
import { GrayHeader } from '../../components/GrayHeader'
import { RaindropIcon, WarningIcon } from '../../../../../components/Svg'
import { Button } from '../../../../../components/Button'
import { corporateColor } from '../../../../../theme/colors'
import { FuelContext } from '../../../../../context/Logistics/fuel/FuelProvider'
import { DOBRA } from '../../../../../theme/fonts'
import { usePost } from '../../../../../hooks/usePost'
import { OrderBody, OrderResponse } from '../Summary/types'
import { paths } from '../../../../../api/pathsApi'
import { useSendRecord } from '../../hooks/useSendRecord'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { AuthContext } from '../../../../../context/Auth/AuthContext'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { NEGATIVE_WATER_LABEL, POSITIVE_WATER_LABEL, PRUEBA_POSITIVA_STATE } from './const'

interface Navigation extends StackNavigationProp<LogisticsRoutes, 'TestResults'> {}

export const TestResult = () => {
  const { user } = useContext(AuthContext)
  const { handleResultTest, form, getStatusForm } = useContext(FuelContext)
  const { t } = useTranslation()
  const navigation = useNavigation<Navigation>()
  const [isSending, setIsSending] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [showError, setShowError] = useState(false)

  const { handleSendRecord } = useSendRecord({
    onSuccess() {
      setShowAlert(true)
      setIsSending(false)
    },
    onError(error) {
      console.log(error)
      setIsSending(false)
      setShowError(true)
    },
  })
  const { handleSendData } = usePost<OrderBody, OrderResponse>({
    url: paths().LOGISTIC.CREATE_ORDER,
    onSuccess(data) {
      handleSendRecord(data.id_order)
    },
    onError(error) {
      console.log(error)
      setIsSending(false)
      setShowError(true)
    },
  })

  const handlePositive = () => {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: 'HomeScreen' }],
      }),
    )
  }
  const handleNegative = () => {
    handleResultTest('Negativo')
    navigation.navigate('InitialPhotoMeter')
  }

  const handleSendOrder = () => {
    setIsSending(true)
    handleResultTest(POSITIVE_WATER_LABEL)
  }

  useEffect(() => {
    if (isSending && getStatusForm().pop()?.id_status === PRUEBA_POSITIVA_STATE) {
      handleSendData({
        ['id_user']: user.userId!,
        order: {
          ['id_naval_artifact']: form.pontoonId!,
          ['id_ship']: form.shipId!,
          ['id_status']: getStatusForm().pop()?.id_status ?? 0,
          ['id_supplier']: form.supplierId!,
          ['meter_value']: 0,
          number: form.orderNumber!,
          ['voucher_number']: form.voucherNumber,
          ['water_test']: true,
          ['order_date']: moment(form.deliveryDate!, 'DD-MM-YYYY').format('YYYY-MM-DD'),
          ['status_detail']: getStatusForm(),
        },
      })
    }
  }, [form, getStatusForm().pop()?.id_status, isSending])

  return (
    <TemplatePage header styleContent={{ padding: 0, marginBottom: 0 }}>
      <View style={[globalStyle.viewContainer, { padding: 0 }]}>
        <GrayHeader title={t('Prueba de agua')} />

        <View style={{ padding: 24, flex: 1, justifyContent: 'center' }}>
          <View style={{ padding: 24, alignItems: 'center' }}>
            <RaindropIcon height={40} width={40} />
            <Text style={style.title}>{t('Resultado de la prueba')}</Text>
            <Text style={style.indications}>
              {t(
                'Selecciona positivo si la prueba señala que hay agua en el combustible, y negativo si la prueba señala que no hay agua en el combustible.',
              )}
            </Text>
          </View>
          <View style={{ flexDirection: 'row', gap: 16, justifyContent: 'center' }}>
            {!isSending && (
              <>
                <Button
                  label={t(POSITIVE_WATER_LABEL)}
                  onPress={handleSendOrder}
                  customStyle={style.positiveBtn}
                />
                <Button
                  label={t(NEGATIVE_WATER_LABEL)}
                  onPress={handleNegative}
                  customStyle={style.negativeBtn}
                />
              </>
            )}
            {isSending && (
              <Button label={t('Enviando')} onPress={() => null} customStyle={style.positiveBtn}>
                <ActivityIndicator />
              </Button>
            )}
          </View>
        </View>
      </View>
      {showAlert && (
        <AlertMessage action={handlePositive} successLabel='Entendido'>
          <View style={{ alignItems: 'center', gap: 8, padding: 24 }}>
            <WarningIcon height={40} width={40} />
            <Text style={style.title}>{t('Atención')}</Text>
            <Text style={style.indications}>
              {t(
                'Atención, si la prueba dio positiva, no debes depositar combustible en el estanque, informa a (Nombre encargado y teléfono).',
              )}
            </Text>
          </View>
        </AlertMessage>
      )}
      {showError && (
        <AlertMessage action={() => setShowError(false)} successLabel='Entendido'>
          <View style={{ alignItems: 'center', gap: 8, padding: 24 }}>
            <Text style={style.title}>{t('Error')}</Text>
            <Text style={style.indications}>
              {t('Hubo un error al enviar la orden, por favor reintente.')}
            </Text>
          </View>
        </AlertMessage>
      )}
    </TemplatePage>
  )
}

const style = StyleSheet.create({
  title: {
    color: corporateColor,
    fontFamily: DOBRA,
    fontSize: 18,
    fontWeight: '500',
    lineHeight: 22,
    marginTop: 8,
  },
  indications: {
    color: corporateColor,
    fontFamily: DOBRA,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 20,
    marginTop: 8,
    textAlign: 'center',
  },
  positiveBtn: {
    marginLeft: 0,
    marginRight: 0,
    backgroundColor: corporateColor,
  },

  negativeBtn: {
    marginLeft: 0,
    marginRight: 0,
  },
})
